<div style="border: 1px dashed">
  <form [formGroup]="reactiveFormGroup" (ngSubmit)="reactiveFormSubmit()">
    <app-layout-container fluid>
      <app-layout-row>
        <app-layout-column [width]="4">
          <span>Reactive form</span>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" offset="4">
          <!-- <app-textbox decorator formControlName="name" caption="Name" [calculateValidationText]="getValidationText" infoText="Your full name"></app-textbox> -->
          <app-textbox decorator formControlName="name" caption="Name" [calculateValidationText]="getValidationText" infoText="Your full name"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-textbox decorator formControlName="email" caption="Email"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="1" [offset]="4">
          <app-textbox decorator formControlName="zip" caption="Zip"></app-textbox>
        </app-layout-column>
        <app-layout-column [width]="3">
          <app-textbox decorator formControlName="city" caption="City"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" [offset]="6">
          <app-checkbox decorator="right-side" formControlName="allowShowPassword" caption="Allow show password" infoText="Only applies to secret based passwords"></app-checkbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" [offset]="4">
          <app-password decorator formControlName="passwordHash" caption="Password (Hashed)" [allowShowPassword]="allowShowPassword()" section="reactiveHash" mode="hash"
            infoText="This is a hash based password"></app-password>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-password decorator formControlName="passwordSecret" caption="Password (Secret)" [allowShowPassword]="allowShowPassword()" section="reactiveSecret" mode="secret"
            infoText="This is a secret based password"></app-password>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-xpath decorator formControlName="xpath" caption="XPath" infoText="What' you think?"></app-xpath>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" [offset]="4">
          <app-singleselectbox decorator formControlName="backgroundColor" caption="Background color" infoText="Please pick a color" [dataSource]="colors()" valueExpr="id"
            displayExpr="name"></app-singleselectbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-singleselectbox decorator formControlName="foregroundColor" caption="Foreground color" infoText="Please pick a color" [dataSource]="colors()" valueExpr="id"
            displayExpr="name"></app-singleselectbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-multiselectbox decorator formControlName="moreColors" caption="More Colors" infoText="Please pick some colors" [dataSource]="colors()" valueExpr="id" displayExpr="name"></app-multiselectbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-multiselectbox decorator formControlName="otherColors" [dataSource]="colors()" valueExpr="id" displayExpr="name"
            caption="Other Colors - please pick all the colors you like and make this a very long text caption"
            infoText="Please pick some colors and then some more colors and finish up with even more colors"></app-multiselectbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" [offset]="4">
          <app-checkbox decorator="right-side" formControlName="receiveNewsletter" caption="Receive newsletter" infoText="We send monthly newsletters"></app-checkbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-datetimebox datetime decorator formControlName="datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
            infoText="Specify a date and a time"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" [offset]="4">
          <app-datetimebox date decorator formControlName="date" caption="Date" minDate="2024-05-01" infoText="Specify just a date and no time"></app-datetimebox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-datetimebox time decorator formControlName="time" caption="Time" [timeInterval]="10" infoText="Specify just a time and no date"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="2" [offset]="4">
          @if (reactiveFormGroup.enabled) {
          <app-layout-row margin="">
            <app-layout-column [width]="4">
              <app-button primary submit width="100%" [disabled]="!reactiveFormGroup.valid">Save</app-button>
            </app-layout-column>
            <app-layout-column [width]="4">
              <app-button secondary width="100%" (buttonClick)="reactiveFormCancel()">Cancel</app-button>
            </app-layout-column>
            <app-layout-column [width]="4">
              <app-button tertiery width="100%" (buttonClick)="reactiveFormClear()">Clear</app-button>
            </app-layout-column>
          </app-layout-row>
          } @else {
          <app-button primary width="100%" (buttonClick)="reactiveFormEdit()">Edit</app-button>
          }
        </app-layout-column>
        <app-layout-column [width]="1">
          <app-button secondary width="100%" (buttonClick)="reactiveFormPatch()" [disabled]="!reactiveFormGroup.disabled">Patch</app-button>
        </app-layout-column>
        <app-layout-column [width]="1">
          <app-button secondary width="100%" (buttonClick)="refresh()" [disabled]="!reactiveFormGroup.disabled">Reload</app-button>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <div>Form: {{reactiveFormGroup.value | json}}</div>
          <br>
          <div>Data: {{this.myData | json}}</div>
        </app-layout-column>
      </app-layout-row>
    </app-layout-container>
  </form>
</div>
